export default {"src":"/_next/static/media/Logo_languex.7203a867.svg","height":39,"width":149,"blurWidth":0,"blurHeight":0};